import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsClimateStore {
  @observable main = '';
  @observable description = '';
  @observable temp = '';
  @observable icon = '';
  @observable defaultLang = true;
  @observable cityName = '';

  @action getData() {
    let lang = window.localStorage.getItem('lang');
    if (!lang) lang = 'en';

    return apiCaller.CmsClimates.get(lang).then(resp => {
      if (resp) {
        if (resp.weather.length > 0) {
          const weatherResult = resp.weather[0];
          this.main = weatherResult.main;
          this.description = weatherResult.description;
          this.icon = `http://openweathermap.org/img/wn/${weatherResult.icon}.png`;
        }

        this.defaultLang = lang === 'en' ? true : false;
        this.temp = resp.main.temp;
        this.cityName = resp.name;
      }
    })
  }
}

export default new CmsClimateStore();